// src/components/AbhaLogin.jsx

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "react-modal";
import { FaCheck, FaTimes } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import secureStorage from "../utils/secureStorage";
import { validateToken } from "../tokenValidation";

const AbhaLogin = () => {
  const inputRefs = useRef([]);
  const location = useLocation();
  const MAX_RESEND_ATTEMPTS = 2;

  const [activeTab, setActiveTab] = useState("mobile");
  const [mobileNumber, setMobileNumber] = useState("");
  const [abhaNumber, setAbhaNumber] = useState(["", "", "", ""]);
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [isCaptchaCorrect, setIsCaptchaCorrect] = useState(false);
  const [linkedProfiles, setLinkedProfiles] = useState(null);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [txnId, setTxnId] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showOtpPopup, setShowOtpPopup] = useState(false);

  const [otp1, setOtp1] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [txnId1, setTxnId1] = useState(null);
  const [txnId2, setTxnId2] = useState(null);
  const [txnId3, setTxnId3] = useState(null); // For ABHA Address
  const [aadhaarResponse, setAadhaarResponse] = useState(null);
  const [type, setType] = useState(null);
  const [abhaAddress, setAbhaAddress] = useState("");
  const [popUp, setpopUp] = useState(false);
  // New State Variables for Resend OTP Functionality
  const [lastOtpPayload, setLastOtpPayload] = useState(null);
  const [resendCooldown, setResendCooldown] = useState(0);
  const [resendLoading, setResendLoading] = useState(false);
  const [mobAuth, setmobAuth] = useState(false);
  const [adharAuth, setadharAuth] = useState(false);
  // New State Variable to Track Resend Attempts
  const [resendCount, setResendCount] = useState(0); // Initialize resend count
  const [otpMessage, setOtpMessage] = useState("");
  const API_URL = process.env.REACT_APP_API_URL;
  console.log(API_URL, "API URL");

  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const queryParam = queryParams.get("queryParam");

  console.log("Query Parameter:", queryParam);

  useEffect(() => {
    validateToken(navigate);
  }, [navigate]);

  // Auto-focus the first OTP input when OTP popup for ABHA Address opens
  useEffect(() => {
    if (showOtpPopup && activeTab === "abha-address" && inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, [showOtpPopup, activeTab]);

  // Cooldown Timer Effect
  useEffect(() => {
    let timer;
    if (resendCooldown > 0) {
      timer = setTimeout(() => setResendCooldown(resendCooldown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [resendCooldown]);

  const handleTabSwitch = (tab) => {
    setActiveTab(tab);
    refreshCaptcha();
    setResendCount(0);
    setLastOtpPayload(null);

    setTxnId1(null);
    setTxnId2(null);
    setTxnId3(null);
  };

  const handleCaptchaChange = (value) => {
    setCaptchaAnswer(value);
    setIsCaptchaCorrect(value === captcha.answer);
  };

  const refreshCaptcha = () => {
    setCaptcha(generateCaptcha());
    setCaptchaAnswer("");
    setIsCaptchaCorrect(false);
  };

  const handleProfileSelection = (index) => {
    setSelectedProfile(index);
  };

  const handleLogin = async () => {
    if (activeTab === "mobile") {
      if (mobileNumber.length !== 10 || !/^[6-9]\d{9}$/.test(mobileNumber)) {
        toast.error(
          "Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9."
        );
        return;
      }
    } else if (activeTab === "abha") {
      // ABHA number validation can be added here if needed
    } else if (activeTab === "abha-address") {
      if (abhaAddress.trim() === "") {
        toast.error("Please enter a valid ABHA Address.");
        return;
      }
    }

    if (!isCaptchaCorrect) {
      toast.error("Captcha is incorrect. Please try again.");
      return;
    }

    setLoading(true);

    try {
      if (activeTab === "mobile") {
        // Existing logic for mobile login
        const response = await fetch(
          `${API_URL}abdm/search-abha-by-mobile?mobileNumber=${mobileNumber}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-HIP-ID": secureStorage.get("clinic") || "",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          if (data && data.data && data.data[0].ABHA) {
            setTxnId(data.data[0].txnId);
            setLinkedProfiles(data.data[0].ABHA);
            setShowPopup(true);
          } else {
            toast.error("No linked profiles found.");
          }
        } else {
          const data = await response.json();
          toast.error(data.data);
          setpopUp(true);

          console.log("errormessage", data);
        }
      } else if (activeTab === "abha") {
        const abhaNumberJoined = abhaNumber.join("-");
        const response = await fetch(
          `${API_URL}abdm/abha-number-search?abhaNumber=${abhaNumberJoined}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-HIP-ID": secureStorage.get("clinic") || "",
            },
          }
        );

        const data = await response.json();
        if (response.ok) {
          if (data && data.data) {
            setShowPopup(true);
          } else {
            toast.error("No linked profiles found for the given ABHA number.");
          }
        } else {
          toast.error(
            data.data ||
              "Failed to login using ABHA number. Please try again later."
          );
        }
      }

      if (activeTab === "abha-address") {
        const clinicId = secureStorage.get("clinic");
        const response = await fetch(
          `${API_URL}abdm/abha-address-search?abhaAddress=${encodeURIComponent(
            abhaAddress
          )}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-HIP-ID": clinicId,
            },
          }
        );

        const data = await response.json();

        if (response.ok && data.status === 200) {
          if (
            data.data.authMethods &&
            data.data.authMethods.includes("MOBILE_OTP")
          ) {
            setmobAuth(true);
          }

          if (
            data.data.authMethods &&
            data.data.authMethods.includes("AADHAAR_OTP")
          ) {
            setadharAuth(true);
          }

          setShowPopup(true);
          toast.success("Address search successful!");
        } else {
          toast.error(data.data || "Failed to send OTP. Please try again.");
        }
      }
    } catch (error) {
      console.error(error);
      toast.error(
        "An error occurred while trying to login. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSendOtp = async () => {
    if (txnId && selectedProfile !== null) {
      setLoading(true);
      const payload = {
        txnId: txnId,
        loginIndex: linkedProfiles[selectedProfile].index,
      };
      setLastOtpPayload({ type: "mobile", payload }); // Store payload

      console.log("Sending OTP with payload:", payload); // Debugging

      try {
        const clinicId = secureStorage.get("clinic");
        const response = await fetch(
          `${API_URL}abdm/search-abha-send-otp?txnId=${encodeURIComponent(
            payload.txnId
          )}&loginIndex=${encodeURIComponent(payload.loginIndex)}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-HIP-ID": clinicId,
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          setTxnId1(data.data.txnId); // Update txnId1 with new txnId
          setOtpMessage(data.data.message);
          toast.success(data.data.message || "OTP sent successfully.");
          setShowPopup(false);
          setShowOtpPopup(true);
          setResendCooldown(60); // Start cooldown
          setResendCount(0); // Reset resend count on new OTP sent
        } else {
          toast.error("Failed to send OTP. Please try again.");
        }
      } catch (error) {
        console.error(error);
        toast.error("Failed to send OTP. Please try again.");
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Please select a profile to proceed.");
    }
  };

  const handleOtpLogin = async () => {
    if (otp1.join("").length === 6) {
      setLoading(true);
      try {
        const clinicId = secureStorage.get("clinic");
        const orgId = secureStorage.get("orgId");
        const response = await fetch(`${API_URL}abdm/login-verify-otp?orgId=${orgId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-HIP-ID": clinicId,
          },
          body: JSON.stringify({
            txnId: txnId1,
            otp: otp1.join(""),
            loginType: "mobile-verify",
          }),
        });

        if (response.ok) {
          const data = await response.json();
          if (data.status === 200) {
            setAadhaarResponse(data.data);
            const userData = { ...data.data };
            toast.success("Login successful!");
            setShowOtpPopup(false);

            console.log("Recovered data : ", userData);
            if (
              Array.isArray(userData.existingProfiles) &&
              userData.existingProfiles.length > 0
            ) {
              navigate("/profile-comparison", {
                state: {
                  abhaProfile: userData.abhaProfile,
                  existingProfiles: userData.existingProfiles,
                },
              });
            } else {
              navigate("/patient-profile", {
                state: {
                  abhaAddress: userData.abhaProfile?.preferredAbhaAddress,
                },
              });
            }
          } else {
            toast.error("Invalid OTP. Please try again.");
          }
        } else {
          toast.error("Failed to verify OTP. Please try again.");
        }
      } catch (error) {
        console.error(error);
        toast.error("Failed to verify OTP. Please try again.");
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Please enter a valid OTP.");
    }
  };

  const handleValidateOption = async (validationType) => {
    setType(validationType);
    console.log(validationType, "Validation Type");
    const abhaNumberJoined = abhaNumber.join("-");
    setLoading(true);

    // Refined payload based on validationType
    const payload =
      validationType === "abha-number"
        ? { loginId: abhaNumberJoined, loginHint: "abha-number" }
        : { loginType: "abha-adhaar", loginHint: abhaNumberJoined };

    // Set precise type based on validationType
    const preciseType =
      validationType === "abha-number" ? "abha-number" : "abha-adhaar";
    setLastOtpPayload({ type: preciseType, payload }); // Store payload

    try {
      const clinicId = secureStorage.get("clinic");
      const response = await fetch(
        validationType === "abha-number"
          ? `${API_URL}abdm/login-mobile-send-otp?loginId=${payload.loginId}&loginHint=${payload.loginHint}`
          : `${API_URL}abdm/login-send-otp?loginType=${payload.loginType}&loginHint=${payload.loginHint}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-HIP-ID": clinicId,
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.status === 200) {
          // Update txnId based on preciseType
          if (preciseType === "abha-number") {
            setTxnId1(data.data.txnId);
          } else if (preciseType === "abha-adhaar") {
            setTxnId2(data.data.txnId);
          }
          setOtpMessage(data.data.message);
          toast.success(data.data.message || "OTP sent successfully.");
          setShowPopup(false);
          setShowOtpPopup(true);
          setResendCooldown(60);
          setResendCount(0);
        } else {
          toast.error(data.message || "Failed to send OTP. Please try again.");
        }
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while sending OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    console.log(type, "Validation Type");
    if (otp1.join("").length !== 6) {
      toast.error("Please enter a valid 6-digit OTP.");
      return;
    }

    setLoading(true);

    try {
      const loginType =
        type === "abha-adhaar" ? "aadhaar-verify" : "mobile-verify";
      const clinicId = secureStorage.get("clinic");
      const orgId = secureStorage.get("orgId");
      const response = await fetch(`${API_URL}abdm/login-verify-otp?orgId=${orgId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-HIP-ID": clinicId },
        body: JSON.stringify({
          txnId: type === "abha-number" ? txnId1 : txnId2,
          otp: otp1.join(""),
          loginType,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.status === 200) {
          setAadhaarResponse(data.data);
          const userData = { ...data.data };
          toast.success("Login successful!");
          setShowOtpPopup(false);

          console.log("Recovered data : ", userData);
          if (
            Array.isArray(userData.existingProfiles) &&
            userData.existingProfiles.length > 0
          ) {
            navigate("/profile-comparison", {
              state: {
                abhaProfile: userData.abhaProfile,
                existingProfiles: userData.existingProfiles,
              },
            });
          } else {
            navigate("/patient-profile", {
              state: {
                abhaAddress: userData.abhaProfile?.preferredAbhaAddress,
              },
            });
          }
        } else {
          toast.error("Invalid OTP. Please try again.");
        }
      } else {
        toast.error("Failed to verify OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      toast.error("An error occurred while verifying OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtpAbha = async () => {
    console.log(type, "Validation Type");
    if (otp1.join("").length !== 6) {
      toast.error("Please enter a valid 6-digit OTP.");
      return;
    }

    setLoading(true);

    try {
      const loginType =
        type === "abha-adhaar" ? "aadhaar-verify" : "mobile-verify";
      const clinicId = secureStorage.get("clinic");
      const orgId = secureStorage.get("orgId");
      const response = await fetch(
        `${API_URL}abdm/verify-login-otp-abhaAddress?orgId=${orgId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-HIP-ID": clinicId },
          body: JSON.stringify({
            txnId: txnId3,
            otp: otp1.join(""),
            loginType,
          }),
        }
      );
      const data = await response.json();
      if (response.ok) {
        if (data.status === 200) {
          setAadhaarResponse(data.data);
          const userData = { ...data.data };

          console.log("User Data before storing", userData);

          toast.success("Login successful!");
          setShowOtpPopup(false);

          const role = secureStorage.get("role");

          if (role === "HOSPITAL") {
            if (
              Array.isArray(userData.existingProfiles) &&
              userData.existingProfiles.length > 0
            ) {
              navigate("/profile-comparison", {
                state: {
                  abhaProfile: userData.abhaProfile,
                  existingProfiles: userData.existingProfiles,
                },
              });
            } else {
              navigate("/patient-profile", {
                state: {
                  abhaAddress: userData.abhaProfile?.preferredAbhaAddress,
                },
              });
            }
          } else {
            localStorage.setItem("user", JSON.stringify(userData));
            navigate("/profile", { state: { aadhaarResponse: userData } });
          }
        } else {
          toast.error("Invalid OTP. Please try again.");
        }
      } else {
        toast.error(data.data || "Failed to verify OTP. Please try again.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while verifying OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleValidateOptionForAbhaAddress = async (validationType) => {
    setShowPopup(false);

    setType(validationType);
    console.log(validationType, "Validation Type");
    setLoading(true);

    const payload = {
      loginHint: abhaAddress,
      loginType:
        validationType === "abha-number" ? "MOBILE_OTP" : "AADHAAR_OTP",
    };

    const preciseType =
      validationType === "abha-number"
        ? "abha-address-number"
        : "abha-address-adhaar";
    setLastOtpPayload({ type: preciseType, payload });

    try {
      const clinicId = secureStorage.get("clinic");
      const response = await fetch(
        `${API_URL}abdm/send-login-otp-abhaAddress?loginType=${payload.loginType}&loginHint=${payload.loginHint}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-HIP-ID": clinicId },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.status === 200) {
          setTxnId3(data.data.txnId); // Update txnId3 with new txnId
          setOtpMessage(data.data.message);
          toast.success(data.data.message || "OTP sent successfully.");
          setShowPopup(false);
          setShowOtpPopup(true);
          setResendCooldown(60); // Start cooldown
          setResendCount(0); // Reset resend count on new OTP sent
        } else {
          toast.error(data.message || "Failed to send OTP. Please try again.");
        }
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while sending OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Updated Function: Handle Resend OTP
  const handleResendOtp = async () => {
    if (!lastOtpPayload) {
      toast.error("No OTP request to resend.");
      return;
    }

    // Check if resend count has exceeded the limit
    if (resendCount >= 2) {
      toast.error("You have reached the maximum number of resend attempts.");
      return;
    }

    const { type: payloadType, payload } = lastOtpPayload;
    setResendLoading(true);

    try {
      let response;
      const clinicId = secureStorage.get("clinic");
      switch (payloadType) {
        case "mobile":
          response = await fetch(
            `${API_URL}abdm/search-abha-send-otp?txnId=${encodeURIComponent(
              payload.txnId
            )}&loginIndex=${encodeURIComponent(payload.loginIndex)}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                "X-HIP-ID": clinicId,
              },
            }
          );
          break;

        case "abha-number":
          response = await fetch(
            `${API_URL}abdm/login-mobile-send-otp?loginId=${payload.loginId}&loginHint=${payload.loginHint}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-HIP-ID": clinicId,
              },
              body: JSON.stringify(payload), // Ensure payload is sent
            }
          );
          break;

        case "abha-adhaar":
          response = await fetch(
            `${API_URL}abdm/login-send-otp?loginType=${payload.loginType}&loginHint=${payload.loginHint}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-HIP-ID": clinicId,
              },
              body: JSON.stringify(payload),
            }
          );
          break;

        case "abha-address-number":
          response = await fetch(
            `${API_URL}abdm/send-login-otp-abhaAddress?loginType=${payload.loginType}&loginHint=${payload.loginHint}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-HIP-ID": clinicId,
              },
              body: JSON.stringify(payload),
            }
          );
          break;

        case "abha-address-adhaar":
          response = await fetch(
            `${API_URL}abdm/send-login-otp-abhaAddress?loginType=${payload.loginType}&loginHint=${payload.loginHint}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-HIP-ID": clinicId,
              },
              body: JSON.stringify(payload),
            }
          );
          break;

        default:
          throw new Error("Invalid OTP type for resend.");
      }

      if (response.ok) {
        const data = await response.json();
        if (data.status === 200) {
          // Update the relevant txnId based on the preciseType
          switch (payloadType) {
            case "mobile":
              setTxnId1(data.data.txnId);
              break;
            case "abha-number":
              setTxnId1(data.data.txnId);
              break;
            case "abha-adhaar":
              setTxnId2(data.data.txnId);
              break;
            case "abha-address-number":
            case "abha-address-adhaar":
              setTxnId3(data.data.txnId);
              break;
            default:
              break;
          }

          toast.success(data.message || "OTP resent successfully.");
          setShowOtpPopup(true);
          setResendCooldown(60); // Restart cooldown
          setResendCount(resendCount + 1); // Increment resend count
        } else {
          toast.error(
            data.message || "Failed to resend OTP. Please try again."
          );
        }
      } else {
        toast.error("Failed to resend OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error resending OTP:", error);
      toast.error("An error occurred while resending OTP. Please try again.");
    } finally {
      setResendLoading(false);
    }
  };

  const handleOtpChange = (value, index) => {
    if (!/^\d*$/.test(value)) return; // Ensure only digits are allowed
    const newOtp = [...otp1];
    newOtp[index] = value;
    setOtp1(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus(); // Move to next field
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp1[index] && index > 0) {
      inputRefs.current[index - 1]?.focus(); // Move focus back
    }
  };

  useEffect(() => {
    if (queryParam) {
      handleTabSwitch("mobile");
      setMobileNumber(queryParam);
    }
  }, []);

  return (
    <div className="bg-gray-100 min-h-screen flex items-center justify-center p-6">
      {/* Loading Indicator */}
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-40">
          <div className="w-16 h-16 border-4 border-t-teal-600 border-gray-300 rounded-full animate-spin"></div>
        </div>
      )}

      {/* Login Card */}
      <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl p-10">
        <h2 className="text-2xl font-bold text-teal-600 mb-8 text-center">
          Verify ABHA Details
        </h2>

        {/* Tabs */}
        <div className="flex mb-8 border-b-2">
          <button
            className={`flex-1 text-center py-2 font-semibold ${
              activeTab === "mobile"
                ? "border-b-4 border-teal-600 text-black"
                : "text-gray-500"
            }`}
            onClick={() => handleTabSwitch("mobile")}
          >
            Mobile Number
          </button>
          <button
            className={`flex-1 text-center py-2 font-semibold ${
              activeTab === "abha"
                ? "border-b-4 border-teal-600 text-black"
                : "text-gray-500"
            }`}
            onClick={() => handleTabSwitch("abha")}
          >
            ABHA Number
          </button>
          <button
            className={`flex-1 text-center py-2 font-semibold ${
              activeTab === "abha-address"
                ? "border-b-4 border-teal-600 text-black"
                : "text-gray-500"
            }`}
            onClick={() => handleTabSwitch("abha-address")}
          >
            ABHA Address
          </button>
        </div>

        {/* Mobile Tab */}
        {activeTab === "mobile" && (
          <div className="mb-8">
            <label
              htmlFor="mobile"
              className="block text-lg font-medium text-black mb-2"
            >
              Mobile number<span className="text-red-500">*</span>
            </label>
            <div className="flex">
              <span className="inline-flex items-center px-4 py-3 border border-gray-300 bg-gray-50 text-gray-600 rounded-l-md">
                +91
              </span>
              <input
                type="text"
                id="mobile"
                placeholder="Enter your mobile number"
                value={mobileNumber || queryParam}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    setMobileNumber(value);
                  }
                }}
                className="w-full p-3 border border-gray-300 rounded-r-md text-black text-lg"
              />
            </div>
          </div>
        )}

        {/* ABHA Number Tab */}
        {activeTab === "abha" && (
          <div className="mb-8">
            <label
              htmlFor="abha"
              className="block text-lg font-medium text-black mb-2"
            >
              Enter ABHA number<span className="text-red-500">*</span>
            </label>
            <div className="flex items-center space-x-2">
              {abhaNumber.map((num, index) => (
                <React.Fragment key={index}>
                  <input
                    type="text"
                    placeholder={index === 0 ? "00" : "0000"}
                    maxLength={index === 0 ? 2 : 4}
                    value={num}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      const updatedAbhaNumber = [...abhaNumber];
                      updatedAbhaNumber[index] = value;
                      if (
                        (index === 0 && value.length === 2) ||
                        (index > 0 && value.length === 4)
                      ) {
                        const nextInput = document.getElementById(
                          `abha-${index + 1}`
                        );
                        if (nextInput) nextInput.focus();
                      }

                      setAbhaNumber(updatedAbhaNumber);
                    }}
                    onKeyDown={(e) => {
                      if (
                        e.key === "Backspace" &&
                        !abhaNumber[index] &&
                        index > 0
                      ) {
                        const prevInput = document.getElementById(
                          `abha-${index - 1}`
                        );
                        if (prevInput) prevInput.focus();
                      }
                    }}
                    className="w-20 p-3 border border-gray-300 rounded-md text-center text-black text-lg"
                    id={`abha-${index}`}
                  />
                  {index < abhaNumber.length - 1 && <span>-</span>}
                </React.Fragment>
              ))}
            </div>
          </div>
        )}

        {/* ABHA Address Tab */}
        {activeTab === "abha-address" && (
          <div className="mb-8">
            <label
              htmlFor="abhaAddress"
              className="block text-lg font-medium text-black mb-2"
            >
              ABHA Address<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="abhaAddress"
              placeholder="Enter your ABHA Address"
              value={abhaAddress}
              onChange={(e) => setAbhaAddress(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md text-black text-lg"
            />
          </div>
        )}

        {/* Captcha */}
        <div className="mb-8">
          <label
            htmlFor="captcha"
            className="block text-lg font-medium text-black mb-2"
          >
            Captcha<span className="text-red-500">*</span>
          </label>
          <div className="flex items-center space-x-4">
            <div className="flex items-center justify-center border border-gray-300 rounded-md w-32 h-14 text-black font-semibold text-xl">
              {captcha.question}
            </div>
            <input
              type="text"
              id="captcha"
              placeholder="Enter answer"
              value={captchaAnswer}
              onChange={(e) => handleCaptchaChange(e.target.value)}
              className="flex-1 p-3 border border-gray-300 rounded-md text-black text-lg"
            />
            <button
              type="button"
              onClick={refreshCaptcha}
              className="text-teal-600 hover:text-teal-800 text-2xl"
              title="Refresh Captcha"
            >
              &#x21bb;
            </button>
          </div>
        </div>

        {/* Next Button */}
        <button
          type="button"
          className={`px-10 py-3 rounded-lg text-lg font-semibold w-full ${
            isCaptchaCorrect
              ? "bg-teal-600 text-white"
              : "bg-gray-300 text-gray-600 cursor-not-allowed"
          }`}
          disabled={!isCaptchaCorrect || loading}
          onClick={handleLogin}
        >
          Next
        </button>

        {/* Forgot ABHA Number */}
        <div className="flex justify-between items-center mt-8 mb-8">
          <button
            onClick={() => navigate("/forgot-abha")}
            className="text-lg text-orange-500 hover:underline"
          >
            Forgot your ABHA number?
          </button>
          {/* <a href="/" className="text-lg text-orange-500 hover:underline">
            Retrieve your Enrollment number
          </a> */}
        </div>
      </div>

      {/* Profile Selection Popup for Mobile */}
      {showPopup && activeTab === "mobile" && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40">
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="w-16 h-16 border-4 border-t-teal-600 border-gray-300 rounded-full animate-spin"></div>
            </div>
          )}
          <div className="bg-white rounded-lg p-6 w-96 relative">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold">Select a Profile</h3>
              <button
                onClick={() => setShowPopup(false)}
                className="text-gray-600 hover:text-gray-900"
              >
                &times;
              </button>
            </div>
            {linkedProfiles && linkedProfiles.length > 0 ? (
              linkedProfiles.map((profile, index) => (
                <div
                  key={index}
                  className={`border p-4 rounded-lg mb-4 cursor-pointer ${
                    selectedProfile === index
                      ? "bg-teal-100 border-teal-600"
                      : "bg-white border-gray-300"
                  }`}
                  onClick={() => handleProfileSelection(index)}
                >
                  <p className="font-medium">{profile.name}</p>
                  <p className="text-sm text-gray-600">
                    Gender: {profile.gender}
                  </p>
                  <p className="text-sm text-gray-600">
                    ABHA Number: {profile.ABHANumber}
                  </p>
                </div>
              ))
            ) : (
              <p className="text-gray-600">No profiles available to display.</p>
            )}
            <button
              className={`px-6 py-3 mt-4 rounded-lg text-lg font-semibold w-full ${
                selectedProfile !== null && !loading
                  ? "bg-teal-600 text-white"
                  : "bg-gray-300 text-gray-600 cursor-not-allowed"
              }`}
              disabled={selectedProfile === null || loading}
              onClick={handleSendOtp}
            >
              {loading ? "Sending OTP..." : "Send OTP"}
            </button>
            <div className="mt-6 text-center">
              <button
                className="text-sm text-blue-600 hover:underline"
                onClick={() => {
                  navigate("/patientSignup");
                }}
              >
                Proceed without ABHA
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Validation Popup for ABHA Number */}
      {showPopup && activeTab === "abha" && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40">
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="w-16 h-16 border-4 border-t-teal-600 border-gray-300 rounded-full animate-spin"></div>
            </div>
          )}
          <div className="bg-white rounded-lg p-6 w-96 relative">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold mb-4">Validate using</h3>
              <button
                onClick={() => setShowPopup(false)}
                className="text-gray-600 hover:text-gray-900"
              >
                &times;
              </button>
            </div>

            <div className="space-y-4">
              <button
                onClick={() => handleValidateOption("abha-number")}
                className="w-full bg-teal-600 text-white py-2 rounded-lg"
              >
                OTP on mobile number linked with ABHA number
              </button>
              <button
                onClick={() => handleValidateOption("abha-adhaar")}
                className="w-full bg-teal-600 text-white py-2 rounded-lg"
              >
                OTP on mobile number linked with Aadhaar number
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Validation Popup for ABHA Address */}
      {showPopup && activeTab === "abha-address" && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40">
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="w-16 h-16 border-4 border-t-teal-600 border-gray-300 rounded-full animate-spin"></div>
            </div>
          )}
          <div className="bg-white rounded-lg p-6 w-96 relative">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold">Validate using</h3>
              <button
                onClick={() => setShowPopup(false)}
                className="text-gray-600 hover:text-gray-900"
              >
                &times;
              </button>
            </div>

            <div className="space-y-4">
              {mobAuth && (
                <button
                  onClick={() =>
                    handleValidateOptionForAbhaAddress("abha-number")
                  }
                  className="w-full bg-teal-600 text-white py-2 rounded-lg"
                >
                  OTP on mobile number linked with ABHA number
                </button>
              )}
              {adharAuth && (
                <button
                  onClick={() =>
                    handleValidateOptionForAbhaAddress("abha-adhaar")
                  }
                  className="w-full bg-teal-600 text-white py-2 rounded-lg"
                >
                  OTP on mobile number linked with Aadhaar number
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* OTP Popup for Mobile */}
      {showOtpPopup && activeTab === "mobile" && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="w-16 h-16 border-4 border-t-teal-600 border-gray-300 rounded-full animate-spin"></div>
            </div>
          )}
          <div className="bg-white rounded-lg p-6 w-96 relative">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold">Enter OTP</h3>
              <button
                onClick={() => setShowOtpPopup(false)}
                className="text-gray-600 hover:text-gray-900"
              >
                &times;
              </button>
            </div>
            <div className="flex space-x-2 mb-4">
              {otp1.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => (inputRefs.current[index] = el)}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target.value, index)}
                  onKeyDown={(e) => handleOtpKeyDown(e, index)}
                  className="w-10 h-12 p-2 border border-gray-300 rounded-md text-center text-black text-lg"
                  placeholder="0"
                />
              ))}
            </div>
            <button
              className={`px-6 py-3 rounded-lg text-lg font-semibold w-full ${
                !loading
                  ? "bg-teal-600 text-white"
                  : "bg-gray-300 text-gray-600 cursor-not-allowed"
              }`}
              disabled={loading}
              onClick={handleOtpLogin}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
            {resendCount < MAX_RESEND_ATTEMPTS && (
              <p className="text-sm text-gray-600 mt-2">
                Didn’t receive OTP?{" "}
                <button
                  type="button"
                  className={`text-teal-600 underline ${
                    resendCooldown > 0 || resendLoading
                      ? "opacity-50 cursor-not-allowed"
                      : "hover:text-teal-800"
                  }`}
                  onClick={handleResendOtp}
                  disabled={resendCooldown > 0 || resendLoading}
                >
                  Resend OTP
                </button>{" "}
                <span className="text-gray-500">
                  ({resendCooldown}s remaining) •{" "}
                  {MAX_RESEND_ATTEMPTS - resendCount}{" "}
                  {MAX_RESEND_ATTEMPTS - resendCount === 1
                    ? "attempt"
                    : "attempts"}{" "}
                  left
                </span>
              </p>
            )}
            {resendCount >= 2 && (
              <span className="text-red-500">Resend OTP exhausted</span>
            )}
          </div>
        </div>
      )}

      {/* OTP Popup for ABHA Number */}
      {showOtpPopup && activeTab === "abha" && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96 relative">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold">Enter OTP</h3>
              <button
                onClick={() => setShowOtpPopup(false)}
                className="text-gray-600 hover:text-gray-900"
              >
                &times;
              </button>
            </div>

            {/* Optional message */}
            <p className="mb-4 text-sm text-gray-700">
              {otpMessage?.trim() ||
                "OTP sent to your registered mobile number"}
            </p>

            {/* Six-box OTP input */}
            <div className="flex space-x-2 mb-4">
              {otp1.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => (inputRefs.current[index] = el)}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target.value, index)}
                  onKeyDown={(e) => handleOtpKeyDown(e, index)}
                  className="w-10 h-12 p-2 border border-gray-300 rounded-md text-center text-black text-lg"
                  placeholder="0"
                />
              ))}
            </div>

            {/* Verify button */}
            <button
              onClick={handleVerifyOtp}
              className={`w-full bg-teal-600 text-white py-2 rounded-lg mb-4 ${
                loading ? "opacity-60 cursor-not-allowed" : "hover:bg-teal-700"
              }`}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify OTP"}
            </button>

            {/* Resend + attempts */}
            {resendCount < MAX_RESEND_ATTEMPTS && (
              <p className="text-sm text-gray-600">
                Didn’t receive OTP?{" "}
                <button
                  type="button"
                  className={`text-teal-600 underline ${
                    resendCooldown > 0 || resendLoading
                      ? "opacity-50 cursor-not-allowed"
                      : "hover:text-teal-800"
                  }`}
                  onClick={handleResendOtp}
                  disabled={resendCooldown > 0 || resendLoading}
                >
                  Resend OTP
                </button>{" "}
                <span className="text-gray-500">
                  ({resendCooldown}s remaining) •{" "}
                  {MAX_RESEND_ATTEMPTS - resendCount}{" "}
                  {MAX_RESEND_ATTEMPTS - resendCount === 1
                    ? "attempt"
                    : "attempts"}{" "}
                  left
                </span>
              </p>
            )}
            {resendCount >= 2 && (
              <span className="text-red-500">Resend OTP exhausted</span>
            )}
          </div>
        </div>
      )}

      {showOtpPopup && activeTab === "abha-address" && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="w-16 h-16 border-4 border-t-teal-600 border-gray-300 rounded-full animate-spin"></div>
            </div>
          )}
          <div className="bg-white rounded-lg p-6 w-96 relative">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold">Enter OTP</h3>
              <button
                onClick={() => setShowOtpPopup(false)}
                className="text-gray-600 hover:text-gray-900"
              >
                &times;
              </button>
            </div>

            <p className="mb-4 text-sm text-gray-700">
              {otpMessage?.trim() ||
                "OTP sent to your registered mobile number"}
            </p>

            <div className="flex space-x-2 mb-4">
              {otp1.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => (inputRefs.current[index] = el)}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target.value, index)}
                  onKeyDown={(e) => handleOtpKeyDown(e, index)}
                  className="w-10 h-12 p-2 border border-gray-300 rounded-md text-center text-black text-lg"
                  placeholder="0"
                />
              ))}
            </div>

            <button
              onClick={handleVerifyOtpAbha}
              className={`w-full bg-teal-600 text-white py-2 rounded-lg mb-4 ${
                loading ? "opacity-60 cursor-not-allowed" : "hover:bg-teal-700"
              }`}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify OTP"}
            </button>

            {resendCount < MAX_RESEND_ATTEMPTS && (
              <p className="text-sm text-gray-600">
                Didn’t receive OTP?{" "}
                <button
                  type="button"
                  className={`text-teal-600 underline ${
                    resendCooldown > 0 || resendLoading
                      ? "opacity-50 cursor-not-allowed"
                      : "hover:text-teal-800"
                  }`}
                  onClick={handleResendOtp}
                  disabled={resendCooldown > 0 || resendLoading}
                >
                  Resend OTP
                </button>{" "}
                <span className="text-gray-500">
                  ({resendCooldown}s remaining) •{" "}
                  {MAX_RESEND_ATTEMPTS - resendCount}{" "}
                  {MAX_RESEND_ATTEMPTS - resendCount === 1
                    ? "attempt"
                    : "attempts"}{" "}
                  left
                </span>
              </p>
            )}
             {resendCount >= 2 && (
              <span className="text-red-500">Resend OTP exhausted</span>
            )}
          </div>
        </div>
      )}

      {/* Toast Notifications */}
      <ToastContainer />

      {/* Modal for User Not Found Scenario */}
      <Modal
        isOpen={popUp}
        onRequestClose={() => setpopUp(false)}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.3)", // Softer background overlay
          },
          content: {
            width: "500px", // Slightly narrower for a cleaner look
            height: "250px",
            margin: "auto",
            padding: "25px",
            borderRadius: "15px", // Smooth rounded corners
            textAlign: "center",
            boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.2)", // Softer, larger shadow
          },
        }}
        ariaHideApp={false}
      >
        <h2 className="text-x font-semibold text-teal-600 mb-6">
          ABHA Number not found, We did not find any ABHA number linked to this
          mobile number. Please use ABHA linked mobile number. Do you want to
          create a new ABHA account?
        </h2>
        <div className="flex flex-row justify-center gap-4">
          <button
            onClick={() => {
              navigate("/healthacnt");
            }}
            className="flex items-center justify-center px-5 py-2 bg-teal-500 text-white rounded-full hover:bg-teal-600 focus:ring-2 focus:ring-teal-300 focus:outline-none transition duration-200"
          >
            <FaCheck className="mr-2" /> Proceed to create ABHA
          </button>

          <button
            onClick={() => {
              navigate("/patientSignup");
            }}
            className="flex items-center justify-center px-5 py-2 bg-gray-300 text-gray-700 rounded-full hover:bg-gray-400 focus:ring-2 focus:ring-gray-200 focus:outline-none transition duration-200"
          >
            <FaTimes className="mr-2" /> Proceed without ABHA
          </button>
        </div>
      </Modal>
    </div>
  );
};

// Captcha Generation Function
const generateCaptcha = () => {
  const num1 = Math.floor(Math.random() * 10);
  const num2 = Math.floor(Math.random() * 10);
  return {
    question: `${num1} + ${num2} = ?`,
    answer: (num1 + num2).toString(),
  };
};

export default AbhaLogin;
